import React, { useEffect, useState } from "react";
import { FaTicketAlt, FaPlaneDeparture, FaMapMarkerAlt } from "react-icons/fa";
import "./Loader.css";

function Loader({ loading }) {
  const [show, setShow] = useState(true);

  useEffect(() => {
    if (!loading) {
      const timer = setTimeout(() => setShow(false), 500);
      return () => clearTimeout(timer);
    }
  }, [loading]);

  if (!show) return null;

  return (
    <div className="loader-container">
      <div className="travel-path">
        <FaTicketAlt className="loader-icon ticket" />
        <div className="dotted-line"></div>
        <FaPlaneDeparture className="loader-icon plane" />
        <div className="dotted-line"></div>
        <FaMapMarkerAlt className="loader-icon location" />
      </div>
    </div>
  );
}

export default Loader;
